module.exports = __webpack_public_path__ + "img/21.9d7b9d89.png";